import Vue from 'vue'
import autocomplete from "./autocomplete";
import inputcomponent from "./inputcomponent";
import dropdown from "./dropdown";
import spinner from "./spinner";
import asidecomponent from "./asidecomponent";
import loader from "./loader";
import navbar from "./navbar";
import select_multiple from "./select_multiple";
import selectecomponent from "./selectecomponent";
import tablecomponent from "./tablecomponent";
import tablecomponent2 from "./tablecomponent2";
import modal from "./modal";
import alert from "./alerts";
import badges from "./badges";
import paginacion from "./paginacion";
import textareacomponent from "./textareacomponent";
import dialogComponent from "./dialogComponent";
import stepper from './stepper'
import gmodal from './modal_component'
import alerta from './alerta'
import simpleCards from "./simpleCards";
import asidebar from "./asidebar";
import headercomponent from "./headercomponent";
import tab_component from "./tab_component";
import serarchMap from './searchMap'
import inputCompleteFile from './input-complete-file'
import tooltip from "./tooltip";
import editorText from "./editorText";
import autocomplete_back from "./autocomplete_back";
import carrousel from "./carrousel";
import tabs from "./tabs";
import AppButton from "./AppButton";

Vue.component('tooltip', tooltip)
Vue.component('autocomplete', autocomplete)
Vue.component('autocompleteBack', autocomplete_back)
Vue.component('inputcomponent', inputcomponent)
Vue.component('dropdown', dropdown)
Vue.component('asidecomponent', asidecomponent)
Vue.component('loader', loader)
Vue.component('navbar', navbar)
Vue.component('select_multiple', select_multiple)
Vue.component('selectecomponent', selectecomponent)
Vue.component('tablecomponent2', tablecomponent2)
Vue.component('tablecomponent', tablecomponent)
Vue.component('modal', modal)
Vue.component('alert', alert)
Vue.component('badges', badges)
Vue.component('paginacion', paginacion)
Vue.component('textareacomponent', textareacomponent)
Vue.component('dialogComponent', dialogComponent)
Vue.component('stepper', stepper)
Vue.component('gmodal', gmodal)
Vue.component('alerta', alerta)
Vue.component('simpleCards', simpleCards)
Vue.component('asidebar', asidebar)
Vue.component('headercomponent', headercomponent)
Vue.component('tab_component', tab_component)
Vue.component('serarchMap', serarchMap)
Vue.component('inputCompleteFile', inputCompleteFile)
Vue.component('editorText', editorText)
Vue.component('carrousel', carrousel)
Vue.component('tabs', tabs)
Vue.component('AppButton', AppButton)
Vue.component('spinner',spinner)

